document.addEventListener("DOMContentLoaded", function () {

/* =====================================================
SUPABASE
===================================================== */

const SUPABASE_URL =
"https://bcahpjxmzkvhixkomomt.supabase.co";

const SUPABASE_KEY =
"sb_publishable_s5dK78dzqY_ujX9BECG5hQ_9fYjTbvh";

/* =====================================================
ELEMENTS
===================================================== */

const form =
document.getElementById("transferBooking");

const toggle =
document.getElementById("tripToggle");

const oneWayText =
document.getElementById("one-way-text");

const roundTripText =
document.getElementById("round-trip-text");

const returnJourney =
document.getElementById("returnJourney");

if (!form) {

console.error(
"TRANSFER BOOKING FORM NOT FOUND"
);

return;

}

/* =====================================================
HTML ESCAPE
===================================================== */

function escapeHtml(value) {

const div =
document.createElement("div");

div.textContent =
value || "";

return div.innerHTML;

}

/* =====================================================
TRIP TOGGLE
===================================================== */

if (toggle) {

toggle.addEventListener(
"change",
function () {

  if (toggle.checked) {

    if (oneWayText) {
      oneWayText.classList.remove("active");
    }

    if (roundTripText) {
      roundTripText.classList.add("active");
    }

    if (returnJourney) {
      returnJourney.style.display = "block";
    }

  } else {

    if (roundTripText) {
      roundTripText.classList.remove("active");
    }

    if (oneWayText) {
      oneWayText.classList.add("active");
    }

    if (returnJourney) {
      returnJourney.style.display = "none";
    }

  }

}

);

}

/* =====================================================
   ADDRESS AUTOCOMPLETE
   FREE OPENSTREETMAP / NOMINATIM
===================================================== */

function setupAddressAutocomplete(
  inputId,
  suggestionsId
) {

  const input =
    document.getElementById(inputId);

  const suggestions =
    document.getElementById(suggestionsId);

  if (!input || !suggestions) {

    console.error(
      "AUTOCOMPLETE ELEMENTS MISSING:",
      inputId,
      suggestionsId
    );

    return;
  }


  let debounceTimer = null;
  let activeController = null;


  /* =================================================
     PROFESSIONAL DROPDOWN (INJECTED CSS)
  ================================================= */

  suggestions.classList.add(
    "creo-addr-drop"
  );


  (function injectDropdownStyles() {

    const styleId =
      "creo-address-dropdown-style";

    if (
      document.getElementById(
        styleId
      )
    ) {

      return;

    }

    const tag =
      document.createElement(
        "style"
      );

    tag.id =
      styleId;

    tag.textContent =
      `.creo-addr-drop{
  background:#ffffff;
  border:1px solid #e6eaf2;
  border-radius:14px;
  box-shadow:0 10px 30px rgba(20,32,60,.14);
  overflow:hidden;
  max-height:360px;
  overflow-y:auto;
}
.creo-addr-drop .address-suggestion{
  box-sizing:border-box;
  width:100%;
  border:0;
  border-bottom:1px solid #eef0f5;
  margin:0;
  background:#ffffff;
  padding:11px 14px;
  text-align:left;
  cursor:pointer;
  display:flex;
  align-items:center;
  gap:12px;
  font-family:inherit;
  transition:background .12s ease;
}
.creo-addr-drop .address-suggestion:last-child{
  border-bottom:0;
}
.creo-addr-drop .address-suggestion:hover,
.creo-addr-drop .address-suggestion.hover{
  background:#f2f7ff;
}
.creo-addr-drop .suggestion-icon{
  width:38px;
  height:38px;
  flex:0 0 38px;
  border-radius:10px;
  background:#f6f2ec;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:17px;
}
.creo-addr-drop .suggestion-text{
  display:flex;
  flex-direction:column;
  gap:3px;
  min-width:0;
  flex:1;
}
.creo-addr-drop .suggestion-line{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:8px;
  min-width:0;
}
.creo-addr-drop .suggestion-text strong{
  font-size:13.5px;
  color:#12141a;
  font-weight:600;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.creo-addr-drop .suggestion-text small{
  font-size:11.5px;
  color:#7a7f8a;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.creo-addr-drop .suggestion-badge{
  flex:0 0 auto;
  font-style:normal;
  font-size:9.5px;
  font-weight:700;
  letter-spacing:.5px;
  text-transform:uppercase;
  background:#f6f2ec;
  color:#a5793f;
  padding:3px 8px;
  border-radius:20px;
  white-space:nowrap;
}
.creo-addr-drop .address-suggestion.loading,
.creo-addr-drop .address-suggestion.no-results{
  justify-content:center;
  font-size:12.5px;
  font-weight:600;
  color:#7a7f8a;
  padding:16px;
}
.creo-addr-drop .address-suggestion.no-results{
  background:#fdf6f4;
  color:#c0453f;
}
`;

    document.head.appendChild(
      tag
    );

  })();


  /* =================================================
     CLEAR
  ================================================= */

  function clearSuggestions() {

    suggestions.innerHTML = "";

    suggestions.style.display = "none";

  }


  /* =================================================
     NORMALIZE TURKISH SEARCH
  ================================================= */

  function normalizeSearchText(value) {

    if (!value) {
      return "";
    }

    return value
      .toLowerCase()
      .trim()
      .replace(/ı/g, "i")
      .replace(/ğ/g, "g")
      .replace(/ü/g, "u")
      .replace(/ş/g, "s")
      .replace(/ö/g, "o")
      .replace(/ç/g, "c")
      .replace(/\s+/g, " ");

  }


  /* =================================================
     SLEEP (Nominatim rate-limit'ine uymak için
     istekler arasına küçük bir bekleme koyuyoruz)
  ================================================= */

  function sleep(ms) {

    return new Promise(function (resolve) {

      setTimeout(resolve, ms);

    });

  }


  /* =================================================
     SEARCH ALIASES
  ================================================= */

  function createSearchQueries(query) {

    const original =
      query.trim();

    const normalized =
      normalizeSearchText(
        original
      );

    const queries = [];

    function addQuery(value) {

      if (
        value &&
        !queries.includes(value)
      ) {

        queries.push(value);

      }

    }


    addQuery(original);


    /*
     * Türkçe karakterleri kaldırılmış
     * versiyon.
     */

    if (
      normalized !==
      original.toLowerCase()
    ) {

      addQuery(normalized);

    }


    /* =================================================
       AIRPORT ALIASES
    ================================================= */

    if (
      normalized.includes(
        "istanbul havalmani"
      ) ||
      normalized.includes(
        "istanbul havalimani"
      ) ||
      normalized.includes(
        "istanbul airport"
      )
    ) {

      addQuery(
        "Istanbul Airport"
      );

      addQuery(
        "İstanbul Havalimanı"
      );

    }


    if (
      normalized.includes(
        "sabiha gokcen"
      ) ||
      normalized.includes(
        "sabiha gokcen airport"
      )
    ) {

      addQuery(
        "Sabiha Gökçen Havalimanı"
      );

      addQuery(
        "Sabiha Gokcen Airport"
      );

    }


    /* =================================================
       COMMON TOURIST PLACES
    ================================================= */

    if (
      normalized ===
      "taksm"
    ) {

      addQuery(
        "Taksim Istanbul"
      );

    }


    if (
      normalized.includes(
        "sultan ahmet"
      ) ||
      normalized.includes(
        "sultanahmet"
      )
    ) {

      addQuery(
        "Sultanahmet Istanbul"
      );

    }


    /* =================================================
       "THE " ÖNEKİ
       OSM'de oteller genelde "The" olmadan kayıtlı
       oluyor (ör. "Ritz-Carlton, Istanbul"), bu yüzden
       başında "The " varsa onsuz halini de deniyoruz.
    ================================================= */

    if (
      /^the\s+/i.test(original)
    ) {

      addQuery(
        original.replace(/^the\s+/i, "")
      );

    }


    /*
     * NOMINATIM RATE-LIMIT KORUMASI:
     * Eskiden 4 sorguya kadar PARALEL istek
     * atılıyordu, bu Nominatim'i bloklayıp
     * "adres bulunamadı" sonucuna yol açıyordu.
     * Artık en fazla 3 sorgu gönderiyoruz.
     */

    return queries.slice(
      0,
      3
    );

  }


  /* =================================================
     PROGRESSIVE QUERIES
     Detaylı adresler için adım adım kısalt
  ================================================= */

  function createProgressiveQueries(query) {

    const list = [];

    function add(q) {

      q = (q || "").trim();

      if (q && !list.includes(q)) {

        list.push(q);

      }

    }

    add(query);

    /* Bina numarasını çıkar */
    const noNumber = query
      .replace(/\bNo\s*\.?\s*:?\s*\d+[A-Za-z0-9\/-]*\b/gi, "")
      .replace(/\bno\.?\s*\d+[A-Za-z0-9\/-]*\b/gi, "")
      .replace(/\b\d+\s*\/\s*[A-Za-z0-9]+\b/g, "")
      .replace(/\b\d{1,4}\b/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/[,\s]+$/, "");

    add(noNumber);

    /* Virgülle ayrılmış kısımları tek tek çıkar */
    const commaParts =
      query
        .split(",")
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean);

    for (
      let i = commaParts.length - 1;
      i >= 1;
      i--
    ) {

      add(
        commaParts.slice(0, i).join(", ")
      );

      add(
        commaParts.slice(-i).join(", ")
      );

    }

    /* Virgülsüz adresler için kelime kelime kısalt */
    const words =
      query
        .split(/\s+/)
        .filter(Boolean);

    for (
      let i = words.length - 1;
      i >= 2;
      i--
    ) {

      add(
        words.slice(0, i).join(" ")
      );

      add(
        words.slice(-i).join(" ")
      );

    }

    /*
     * NOMINATIM RATE-LIMIT KORUMASI:
     * Eskiden 7 aşamalı sorguya kadar deneniyordu,
     * her biri ayrı bir istek anlamına geliyordu.
     * Artık en fazla 3 tanesini deniyoruz.
     */

    return list.slice(0, 4);

  }


  function getPlaceBadge(place) {

    const type =
      (place.type || "").toLowerCase();

    const cls =
      (place.class || "").toLowerCase();

    const name =
      (place.display_name || "")
        .toLowerCase()
        .split(",")[0];

    const hotelTypes =
      ["hotel", "motel", "guest_house", "hostel", "apartment"];

    const foodTypes =
      ["restaurant", "cafe", "fast_food", "bar", "pub", "food_court"];

    if (hotelTypes.indexOf(type) !== -1) {

      return { icon: "🏨", label: "Otel" };

    }

    if (foodTypes.indexOf(type) !== -1) {

      return { icon: "🍽️", label: "Restoran" };

    }

    if (
      cls === "aeroway" ||
      type === "aerodrome" ||
      type === "airport" ||
      (
        (name.includes("havaliman") || name.includes("airport")) &&
        !name.includes("otel") &&
        !name.includes("hotel")
      )
    ) {

      return { icon: "✈️", label: "Havalimanı" };

    }

    if (
      name.includes("otel") ||
      name.includes("hotel")
    ) {

      return { icon: "🏨", label: "Otel" };

    }

    if (
      name.includes("restoran") ||
      name.includes("restaurant") ||
      name.includes("lokanta")
    ) {

      return { icon: "🍽️", label: "Restoran" };

    }

    if (
      type === "resort" ||
      type === "villa" ||
      type === "beach_resort"
    ) {

      return { icon: "🏖️", label: "Tesis" };

    }

    if (
      type === "attraction" ||
      type === "museum"
    ) {

      return { icon: "🏛️", label: "Gezilecek yer" };

    }

    if (cls === "building") {

      return { icon: "🏢", label: "Bina" };

    }

    if (
      type === "road" ||
      type === "highway" ||
      type === "pedestrian" ||
      type === "street" ||
      cls === "highway"
    ) {

      return { icon: "🛣️", label: "Cad / Sokak" };

    }

    if (
      type === "suburb" ||
      type === "neighbourhood" ||
      type === "quarter" ||
      type === "hamlet" ||
      type === "village" ||
      type === "district" ||
      type === "locality"
    ) {

      return { icon: "🏘️", label: "Mahalle" };

    }

    if (
      type === "city" ||
      type === "town" ||
      type === "county" ||
      type === "state"
    ) {

      return { icon: "🏙️", label: "Şehir" };

    }

    return { icon: "📍", label: "Konum" };

  }

/* =================================================
     LOADING
  ================================================= */

  function showLoading() {

    suggestions.innerHTML = `
      <div class="address-suggestion loading">
        🔎 Searching locations...
      </div>
    `;

    suggestions.style.display =
      "block";

  }


  /* =================================================
     NO RESULTS
  ================================================= */

  function showNoResults() {

    suggestions.innerHTML = `
      <div class="address-suggestion no-results">
        No location found
      </div>
    `;

    suggestions.style.display =
      "block";

  }


  /* =================================================
     GEOAPIFY KEY (OPSİYONEL)
     Doldurulursa oteller dahil POI'leri bulur
  ================================================= */

  const GEOAPIFY_KEY =
    (typeof window !== "undefined" &&
      (window.GEOAPIFY_API_KEY || "")
    )
      .trim();


  /* =================================================
     İSTANBUL SINIRLARI
  ================================================= */

  const ISTANBUL_BBOX = {
    minLon: 27.95,
    minLat: 40.78,
    maxLon: 29.97,
    maxLat: 41.62
  };

  const ISTANBUL_CENTER = {
    lat: 41.0082,
    lon: 28.9784
  };

  const OTHER_PROVINCES = [
    "kocaeli",
    "tekirdag",
    "yalova",
    "sakarya",
    "bursa",
    "kirklareli",
    "edirne",
    "bilecik"
  ];

  function isInsideIstanbulBox(lat, lon) {

    lat = parseFloat(lat);
    lon = parseFloat(lon);

    if (isNaN(lat) || isNaN(lon)) {
      return false;
    }

    return (
      lat >= ISTANBUL_BBOX.minLat &&
      lat <= ISTANBUL_BBOX.maxLat &&
      lon >= ISTANBUL_BBOX.minLon &&
      lon <= ISTANBUL_BBOX.maxLon
    );

  }

  function isIstanbulPlace(place) {

    if (!isInsideIstanbulBox(place.lat, place.lon)) {
      return false;
    }

    const text =
      normalizeSearchText(
        place.display_name || ""
      );

    if (text.includes("stanbul")) {
      return true;
    }

    for (let i = 0; i < OTHER_PROVINCES.length; i++) {

      if (text.includes(OTHER_PROVINCES[i])) {
        return false;
      }

    }

    return true;

  }

  function buildDisplayName(parts) {

    const out = [];
    const seen = {};

    parts.forEach(function (part) {

      part = (part || "").toString().trim();

      if (!part) {
        return;
      }

      const key = normalizeSearchText(part);

      if (seen[key]) {
        return;
      }

      seen[key] = true;
      out.push(part);

    });

    return out.join(", ");

  }


  /* =================================================
     PHOTON (OpenStreetMap — otel/restoran/havalimanı)
  ================================================= */

  async function searchPhoton(query, signal) {

    const params =
      new URLSearchParams({

        q:
          query,

        limit:
          "12",

        lang:
          "default",

        lat:
          String(ISTANBUL_CENTER.lat),

        lon:
          String(ISTANBUL_CENTER.lon),

        bbox:
          [
            ISTANBUL_BBOX.minLon,
            ISTANBUL_BBOX.minLat,
            ISTANBUL_BBOX.maxLon,
            ISTANBUL_BBOX.maxLat
          ].join(",")

      });


    const response =
      await fetch(
        "https://photon.komoot.io/api/?" +
        params.toString(),
        {
          method:
            "GET",

          headers: {
            "Accept":
              "application/json"
          },

          signal:
            signal
        }
      );


    if (!response.ok) {

      throw new Error(
        "Photon HTTP " +
        response.status
      );

    }


    const data =
      await response.json();

    const features =
      (data && data.features) ||
      [];


    return features.map(
      function (feature) {

        const p =
          feature.properties ||
          {};

        const coords =
          (
            feature.geometry &&
            feature.geometry.coordinates
          ) ||
          [];

        const name =
          p.name ||
          "";

        const street =
          p.street
            ? (
                p.street +
                (
                  p.housenumber
                    ? " No:" + p.housenumber
                    : ""
                )
              )
            : "";

        const area =
          p.district ||
          p.locality ||
          "";

        const city =
          p.city ||
          p.county ||
          "";

        const isArea =
          p.osm_key === "place" ||
          p.osm_key === "boundary";

        /*
         * Mevcut liste kodu address.road / neighbourhood /
         * suburb / town / city alanlarını birleştirip başlık
         * yapıyor. Otel adı görünsün diye adı "road" alanına
         * koyuyoruz.
         */

        const address =
          isArea
            ? {
                road: "",
                neighbourhood: "",
                suburb: name,
                town: (area && area !== name) ? area : "",
                city: city
              }
            : {
                road: name || p.street || "",
                neighbourhood: name ? street : "",
                suburb: area,
                town: "",
                city: city
              };

        return {

          place_id:
            (p.osm_type || "") +
            (p.osm_id || ""),

          osm_type:
            p.osm_type,

          osm_id:
            p.osm_id,

          lat:
            coords[1],

          lon:
            coords[0],

          display_name:
            buildDisplayName([
              name,
              street,
              area,
              city,
              p.state
            ]),

          address:
            address,

          type:
            p.osm_value ||
            "",

          class:
            p.osm_key ||
            ""

        };

      }
    );

  }


  /* =================================================
     GEOAPIFY (opsiyonel anahtar)
  ================================================= */

  async function searchGeoapify(
    query,
    signal
  ) {

    const params =
      new URLSearchParams({

        text:
          query,

        apiKey:
          GEOAPIFY_KEY,

        lang:
          "tr",

        format:
          "geojson",

        limit:
          "10",

        filter:
          "circle:" +
          ISTANBUL_CENTER.lon + "," +
          ISTANBUL_CENTER.lat + ",80000",

        bias:
          "proximity:" +
          ISTANBUL_CENTER.lon + "," +
          ISTANBUL_CENTER.lat

      });


    const response =
      await fetch(
        "https://api.geoapify.com/v1/geocode/search?" +
        params.toString(),
        {
          method:
            "GET",

          headers: {
            "Accept":
              "application/json"
          },

          signal:
            signal
        }
      );


    if (!response.ok) {

      throw new Error(
        "Geoapify HTTP " +
        response.status
      );

    }


    const data =
      await response.json();

    const features =
      (data && data.features) ||
      [];


    return features.map(
      function (feature) {

        const props =
          feature.properties ||
          {};

        const cat =
          (props.category || "")
            .toLowerCase();

        let type =
          props.result_type ||
          "";

        let cls =
          "";

        if (cat.indexOf("accommodation") === 0) {

          type = "hotel";
          cls = "tourism";

        } else if (cat.indexOf("catering") === 0) {

          type = "restaurant";
          cls = "amenity";

        } else if (cat.indexOf("airport") !== -1) {

          type = "aerodrome";
          cls = "aeroway";

        }

        const name =
          props.name ||
          "";

        const street =
          props.street
            ? (
                props.street +
                (
                  props.housenumber
                    ? " No:" + props.housenumber
                    : ""
                )
              )
            : "";

        return {

          place_id:
            props.place_id ||
            (
              props.lat +
              "_" +
              props.lon
            ),

          lat:
            props.lat,

          lon:
            props.lon,

          display_name:
            props.formatted ||
            buildDisplayName([
              name,
              street,
              props.suburb,
              props.city
            ]),

          address: {

            road:
              name ||
              props.street ||
              "",

            neighbourhood:
              name
                ? street
                : "",

            suburb:
              props.district ||
              props.suburb ||
              "",

            town:
              "",

            city:
              props.city ||
              props.county ||
              ""

          },

          type:
            type,

          class:
            cls

        };

      }
    );

  }


  /* =================================================
     NOMINATIM (yedek — İstanbul kutusuna sınırlı)
  ================================================= */

  async function searchNominatimBounded(
    query,
    signal
  ) {

    const params =
      new URLSearchParams({

        format:
          "jsonv2",

        addressdetails:
          "1",

        limit:
          "15",

        dedupe:
          "0",

        "accept-language":
          "tr,en",

        q:
          query,

        countrycodes:
          "tr",

        viewbox:
          [
            ISTANBUL_BBOX.minLon,
            ISTANBUL_BBOX.maxLat,
            ISTANBUL_BBOX.maxLon,
            ISTANBUL_BBOX.minLat
          ].join(","),

        bounded:
          "1"

      });


    const response =
      await fetch(
        "https://nominatim.openstreetmap.org/search?" +
        params.toString(),
        {
          method:
            "GET",

          headers: {
            "Accept":
              "application/json"
          },

          signal:
            signal
        }
      );


    if (!response.ok) {

      throw new Error(
        "Nominatim HTTP " +
        response.status
      );

    }


    const list =
      await response.json();

    if (!Array.isArray(list)) {

      return [];

    }


    return list.map(
      function (p) {

        const a =
          p.address ||
          {};

        const isStreet =
          p.category === "highway";

        const name =
          p.name ||
          "";

        p.class =
          p.class ||
          p.category ||
          "";

        if (name && name !== a.road) {

          p.address = {

            road:
              name,

            neighbourhood:
              isStreet
                ? ""
                : (a.road || ""),

            suburb:
              a.suburb ||
              a.neighbourhood ||
              "",

            town:
              a.town ||
              a.county ||
              "",

            city:
              a.city ||
              a.province ||
              ""

          };

        }

        return p;

      }
    );

  }


  /* =================================================
     ANA ARAMA — (eski adı korundu: searchNominatim)
     Sırayla: Geoapify (anahtar varsa) → Photon → Nominatim
     "country" parametresi artık kullanılmıyor, hep İstanbul.
  ================================================= */

  async function searchNominatim(
    query,
    signal,
    country
  ) {

    let results;

    if (GEOAPIFY_KEY) {

      try {

        results =
          await searchGeoapify(
            query,
            signal
          );

        if (results.length) {
          return results;
        }

      } catch (geoError) {

        if (geoError.name === "AbortError") {
          throw geoError;
        }

        console.warn(
          "GEOAPIFY FAILED:",
          geoError
        );

      }

    }


    try {

      results =
        await searchPhoton(
          query,
          signal
        );

      if (results.length) {
        return results;
      }

    } catch (photonError) {

      if (photonError.name === "AbortError") {
        throw photonError;
      }

      console.warn(
        "PHOTON FAILED:",
        photonError
      );

    }


    return await searchNominatimBounded(
      query,
      signal
    );

  }/* =================================================
     SEARCH
  ================================================= */

  async function searchAddresses(
    query
  ) {

    if (
      !query ||
      query.length < 2
    ) {

      clearSuggestions();

      return;

    }


    try {

      if (activeController) {

        activeController.abort();

      }


      activeController =
        new AbortController();


      const queries =
        createSearchQueries(
          query
        );


      console.log(
        "SEARCH QUERIES:",
        queries
      );


      /* =================================================
         ALIAS QUERIES (HAVALİMANI VB)
      ================================================= */

      const aliasQueries =
        queries;


      /* =================================================
         PROGRESSIVE QUERIES
         Detaylı adres için aşamalı kısaltma
      ================================================= */

      const progressiveQueries =
        createProgressiveQueries(
          query
        );


      console.log(
        "PROGRESSIVE QUERIES:",
        progressiveQueries
      );


      /* =================================================
         SEARCH BATCH (SIRALI — PARALEL DEĞİL)
         NOT: Nominatim aynı anda birden fazla isteği
         "kötüye kullanım" sayıp IP'yi geçici olarak
         bloke edebiliyor ("adres bulunamadı" hatasının
         en yaygın sebebi budur). Bu yüzden istekleri
         art arda (sırayla), aralarına kısa bir bekleme
         koyarak gönderiyoruz.
      ================================================= */

      async function searchBatch(
        queryList,
        country
      ) {

        const list =
          [];

        const seenSet =
          new Set();


        for (
          let i = 0;
          i < queryList.length;
          i++
        ) {

          if (i > 0) {

            await sleep(220);

          }

          let resultList;

          try {

            resultList =
              await searchNominatim(
                queryList[i],
                activeController.signal,
                country
              );

          } catch (batchError) {

            if (
              batchError.name ===
              "AbortError"
            ) {

              throw batchError;

            }

            console.error(
              "BATCH QUERY FAILED:",
              queryList[i],
              batchError
            );

            continue;

          }


          if (
            !Array.isArray(
              resultList
            )
          ) {

            continue;

          }


          resultList.forEach(
            function (place) {

              const key =
                String(
                  place.place_id ||
                    (
                      place.lat +
                      "_" +
                      place.lon
                    )
                );


              if (
                !seenSet.has(key)
              ) {

                seenSet.add(key);

                list.push(
                  place
                );

              }

            }
          );


          /*
           * Yeterli sonuç bulduysak
           * gereksiz yere devam etmeyelim
           * (daha az istek = daha az rate-limit riski)
           */

          if (
            list.length >= 8
          ) {

            break;

          }

        }

        return list;

      }


      let merged =
        await searchBatch(
          aliasQueries,
          "tr"
        );


      if (
        merged.length === 0
      ) {

        await sleep(150);

        merged =
          await searchBatch(
            progressiveQueries,
            "tr"
          );

      }


      /* Sadece İstanbul */

      merged =
        merged.filter(
          isIstanbulPlace
        );


      if (
        merged.length === 0
      ) {

        showNoResults();

        return;

      }


      /* =================================================
         SORT / PRIORITY
      ================================================= */

      /* "İ" harfi küçültülünce "i" + birleşik nokta oluyor; noktayı at */

      function normalizeForScore(value) {

        return normalizeSearchText(value)
          .replace(/\u0307/g, "");

      }


      const queryNormalized =
        normalizeForScore(
          query
        );


      function scorePlace(place) {

        const full =
          normalizeForScore(
            place.display_name || ""
          );

        const first =
          full.split(",")[0].trim();

        const type =
          (place.type || "").toLowerCase();

        const cls =
          (place.class || "").toLowerCase();

        let score = 0;

        if (first === queryNormalized) {

          score += 40;

        } else if (first.indexOf(queryNormalized) === 0) {

          score += 30;

        } else if (first.indexOf(queryNormalized) !== -1) {

          score += 20;

        } else if (full.indexOf(queryNormalized) !== -1) {

          score += 10;

        }

        if (
          cls === "aeroway" ||
          type === "aerodrome"
        ) {

          score += 10;

        } else if (
          type === "hotel" ||
          type === "motel" ||
          type === "guest_house" ||
          type === "hostel"
        ) {

          score += 6;

        } else if (
          type === "restaurant" ||
          type === "cafe"
        ) {

          score += 4;

        }

        return score;

      }


      merged.sort(
        function (a, b) {

          return scorePlace(b) - scorePlace(a);

        }
      );

      /* =================================================
         SHOW RESULTS
      ================================================= */

      suggestions.innerHTML =
        "";


      merged
        .slice(
          0,
          8
        )
        .forEach(
          function (place) {

            const item =
              document.createElement(
                "button"
              );


            item.type =
              "button";


            item.className =
              "address-suggestion";


            let displayName =
              place.display_name ||
              "";


            displayName =
              displayName
                .replace(
                  /,\s*Türkiye$/i,
                  ""
                )
                .replace(
                  /,\s*Turkey$/i,
                  ""
                );


            let shortName =
              displayName;


            if (
              place.address
            ) {

              const address =
                place.address;


              const parts =
                [];


              if (
                address.road
              ) {

                parts.push(
                  address.road
                );

              }


              if (
                address.neighbourhood
              ) {

                parts.push(
                  address.neighbourhood
                );

              }


              if (
                address.suburb
              ) {

                parts.push(
                  address.suburb
                );

              }


              if (
                address.town
              ) {

                parts.push(
                  address.town
                );

              }


              if (
                address.city
              ) {

                parts.push(
                  address.city
                );

              }


              if (
                parts.length
              ) {

                shortName =
                  parts.join(
                    ", "
                  );

              }

            }


            const badge =
              getPlaceBadge(place);


            item.innerHTML = `

              <span class="suggestion-icon">
                ${badge.icon}
              </span>

              <span class="suggestion-text">

                <span class="suggestion-line">

                  <strong>
                    ${escapeHtml(
                      shortName
                    )}
                  </strong>

                  <em class="suggestion-badge">
                    ${escapeHtml(
                      badge.label
                    )}
                  </em>

                </span>

                <small>
                  ${escapeHtml(
                    displayName
                  )}
                </small>

              </span>

            `;


            /* =================================================
               SELECT
            ================================================= */

            item.addEventListener(
              "click",
              function () {

                input.value =
                  displayName;


                /* =================================================
                   SAVE COORDINATES
                ================================================= */

                input.dataset.lat =
                  place.lat;


                input.dataset.lon =
                  place.lon;


                /* =================================================
                   OSM DATA
                ================================================= */

                if (
                  place.place_id
                ) {

                  input.dataset.placeId =
                    place.place_id;

                }


                if (
                  place.osm_type
                ) {

                  input.dataset.osmType =
                    place.osm_type;

                }


                if (
                  place.osm_id
                ) {

                  input.dataset.osmId =
                    place.osm_id;

                }


                /* =================================================
                   AIRPORT DETECTION
                ================================================= */

                const placeText =
                  (
                    place.display_name ||
                    ""
                  )
                    .toLowerCase();


                const placeType =
                  (
                    place.type ||
                    ""
                  )
                    .toLowerCase();


                const placeClass =
                  (
                    place.class ||
                    ""
                  )
                    .toLowerCase();


                const addressText =
                  JSON.stringify(
                    place.address ||
                    {}
                  )
                    .toLowerCase();


                const placeFirstName =
                  placeText.split(",")[0];

                const isHotelOrFood =
                  [
                    "hotel", "motel", "guest_house", "hostel",
                    "apartment", "restaurant", "cafe", "fast_food"
                  ].indexOf(placeType) !== -1 ||
                  /otel|hotel|resort|restoran|restaurant|cafe|kafe|lokanta/
                    .test(placeFirstName);

                const airportDetected =
                  !isHotelOrFood &&
                  (
                    placeClass === "aeroway" ||
                    placeType === "aerodrome" ||
                    placeType === "airport" ||
                    placeText.includes("airport") ||
                    placeText.includes("havaliman") ||
                    placeText.includes("sabiha") ||
                    addressText.includes("airport") ||
                    addressText.includes("havaliman")
                  );


                input.dataset.isAirport =
                  airportDetected
                    ? "true"
                    : "false";


                input.dataset.addressSelected =
                  "true";


                /* =================================================
                   CLOSE
                ================================================= */

                clearSuggestions();


                /* =================================================
                   CHANGE
                ================================================= */

                input.dispatchEvent(
                  new Event(
                    "change",
                    {
                      bubbles:
                        true
                    }
                  )
                );


                console.log(
                  "ADDRESS SELECTED:",
                  {
                    address:
                      displayName,

                    lat:
                      place.lat,

                    lon:
                      place.lon,

                    isAirport:
                      airportDetected
                  }
                );

              }
            );


            suggestions.appendChild(
              item
            );

          }
        );


      suggestions.style.display =
        "block";


    } catch (error) {

      if (
        error.name ===
        "AbortError"
      ) {

        return;

      }


      console.error(
        "ADDRESS SEARCH ERROR:",
        error
      );


      clearSuggestions();

    }

  }


  /* =================================================
     INPUT
  ================================================= */

  input.addEventListener(
    "input",
    function () {

      const query =
        input.value.trim();


      /*
       * Kullanıcı tekrar yazmaya
       * başladıysa eski koordinatları sil.
       */

      delete input.dataset.lat;
      delete input.dataset.lon;
      delete input.dataset.placeId;
      delete input.dataset.osmType;
      delete input.dataset.osmId;
      delete input.dataset.isAirport;


      input.dataset.addressSelected =
        "false";


      clearTimeout(
        debounceTimer
      );


      if (
        query.length < 2
      ) {

        clearSuggestions();

        return;

      }


      debounceTimer =
        setTimeout(
          function () {

            showLoading();

            searchAddresses(
              query
            );

          },
          650
        );

    }
  );


  /* =================================================
     FOCUS
  ================================================= */

  input.addEventListener(
    "focus",
    function () {

      const query =
        input.value.trim();


      if (
        query.length >= 2
      ) {

        showLoading();

        searchAddresses(
          query
        );

      }

    }
  );


  /* =================================================
     ESCAPE
  ================================================= */

  input.addEventListener(
    "keydown",
    function (event) {

      if (
        event.key ===
        "Escape"
      ) {

        clearSuggestions();

      }

    }
  );


  /* =================================================
     OUTSIDE CLICK
  ================================================= */

  document.addEventListener(
    "click",
    function (event) {

      if (
        !input.contains(
          event.target
        ) &&
        !suggestions.contains(
          event.target
        )
      ) {

        clearSuggestions();

      }

    }
  );

}

/* =====================================================
INITIALIZE AUTOCOMPLETE
===================================================== */

setupAddressAutocomplete(
"pickup",
"pickupSuggestions"
);

setupAddressAutocomplete(
"dropoff",
"dropoffSuggestions"
);

setupAddressAutocomplete(
"returnPickup",
"returnPickupSuggestions"
);

setupAddressAutocomplete(
"returnDropoff",
"returnDropoffSuggestions"
);

/* =====================================================
AIRPORT DETECTION
===================================================== */

function isAirport(
value
) {

if (!value) {
return false;
}

const addressInputIds =
    ["pickup", "dropoff", "returnPickup", "returnDropoff"];

  for (let i = 0; i < addressInputIds.length; i++) {

    const el =
      document.getElementById(
        addressInputIds[i]
      );

    if (
      el &&
      el.dataset.addressSelected === "true" &&
      el.value.trim() === String(value).trim()
    ) {

      return el.dataset.isAirport === "true";

    }

  }

const text =
value
.toLowerCase()
.trim();

return (

text.includes(
  "istanbul havalimanı"
) ||

text.includes(
  "istanbul havalimani"
) ||

text.includes(
  "istanbul airport"
) ||

text.includes(
  "istanbul havaliman"
) ||

text.includes(
  "sabiha gökçen"
) ||

text.includes(
  "sabiha gokcen"
) ||

text.includes(
  "sabiha gökçen havalimanı"
) ||

text.includes(
  "sabiha gokcen havalimani"
) ||

text.includes(
  "sabiha gokcen airport"
) ||

text.includes(
  "sabiha gökçen airport"
) ||

text.includes(
  "airport"
) ||

text.includes(
  "havaliman"
) ||

text.includes(
  "havalimanı"
) ||

text ===
  "ist" ||

text ===
  "saw" ||

text.includes(
  "(ist)"
) ||

text.includes(
  "(saw)"
)

);

}

/* =====================================================
FLIGHT INPUT
===================================================== */

function getFlightInput(
wrapperId,
preferredId
) {

const wrapper =
document.getElementById(
wrapperId
);

if (!wrapper) {
return null;
}

if (preferredId) {

const input =
  document.getElementById(
    preferredId
  );


if (
  input &&
  wrapper.contains(input)
) {

  return input;

}

}

return wrapper.querySelector(
"input"
);

}

/* =====================================================
FLIGHT BOX
===================================================== */

function setupFlightBox(
locationId,
wrapperId,
flightId
) {

const locationInput =
document.getElementById(
locationId
);

const flightWrapper =
document.getElementById(
wrapperId
);

if (
!locationInput ||
!flightWrapper
) {

console.warn(
  "FLIGHT ELEMENT NOT FOUND:",
  locationId,
  wrapperId
);

return;

}

function checkFlightBox() {

const airportByDataset =
  locationInput.dataset.isAirport ===
  "true";


const airportByText =
  isAirport(
    locationInput.value
  );


const airport =
  airportByDataset ||
  airportByText;


if (airport) {

  flightWrapper.style.display =
    "flex";

} else {

  flightWrapper.style.display =
    "none";


  const flightInput =
    getFlightInput(
      wrapperId,
      flightId
    );


  if (flightInput) {

    flightInput.value =
      "";

  }

}

}

locationInput.addEventListener(
"input",
function () {

  /*
   * Kullanıcı yazarken eski airport
   * bilgisini dikkate alma.
   */

  checkFlightBox();

}

);

locationInput.addEventListener(
"change",
checkFlightBox
);

locationInput.addEventListener(
"blur",
checkFlightBox
);

checkFlightBox();

}

/* =====================================================
FLIGHT BOXES
===================================================== */

setupFlightBox(
"pickup",
"pickupFlightWrapper",
"pickupFlight"
);

setupFlightBox(
"dropoff",
"dropoffFlightWrapper",
"dropoffFlightNumber"
);

setupFlightBox(
"returnPickup",
"returnPickupFlightWrapper",
"returnPickupFlightNumber"
);

setupFlightBox(
"returnDropoff",
"returnDropoffFlightWrapper",
"returnDropoffFlightNumber"
);
/* =====================================================
   VEHICLE SELECTION + PASSENGER LIMIT
===================================================== */

const vehicleCards =
  document.querySelectorAll(
    ".vehicle-card"
  );


const passengersInput =
  document.getElementById(
    "passengers"
  );


/* =====================================================
   MAX PASSENGERS
===================================================== */

function getMaxPassengers(
  vehicleName
) {

  const lowerName =
    vehicleName
      .toLowerCase();


  /* VIP VITO */

  if (
    lowerName.includes("vip") &&
    lowerName.includes("vito")
  ) {

    return 5;

  }


  /* VITO */

  if (
    lowerName.includes("vito")
  ) {

    return 6;

  }


  /* SPRINTER */

  if (
    lowerName.includes("sprinter")
  ) {

    return 15;

  }


  /* SEDAN */

  return 3;

}


/* =====================================================
   UPDATE PASSENGER LIMIT
===================================================== */

function updatePassengerLimit(
  vehicleName
) {

  if (!passengersInput) {
    return;
  }


  const maxPassengers =
    getMaxPassengers(
      vehicleName
    );


  /* HTML MAX */

  passengersInput.max =
    maxPassengers;


  /* CURRENT VALUE */

  let currentPassengers =
    parseInt(
      passengersInput.value ||
      "1",
      10
    );


  if (
    isNaN(
      currentPassengers
    ) ||
    currentPassengers < 1
  ) {

    currentPassengers =
      1;

  }


  /* TOO MANY */

  if (
    currentPassengers >
    maxPassengers
  ) {

    passengersInput.value =
      maxPassengers;

  }


  console.log(
    "PASSENGER LIMIT:",
    {
      vehicle:
        vehicleName,

      maxPassengers:
        maxPassengers
    }
  );

}


/* =====================================================
   VEHICLE CLICK
===================================================== */

vehicleCards.forEach(
  function (card) {

    card.addEventListener(
      "click",
      function () {

        /* REMOVE ACTIVE */

        vehicleCards.forEach(
          function (item) {

            item.classList.remove(
              "active"
            );

          }
        );


        /* ADD ACTIVE */

        card.classList.add(
          "active"
        );


        /* GET VEHICLE NAME */

        const title =
          card.querySelector(
            "h4"
          );


        const vehicleName =
          title
            ? title.textContent.trim()
            : "Economy Sedan";


        /* UPDATE PASSENGER LIMIT */

        updatePassengerLimit(
          vehicleName
        );

      }
    );

  }
);


/* =====================================================
   INITIAL VEHICLE
===================================================== */

const initialVehicle =
  document.querySelector(
    ".vehicle-card.active"
  );


if (initialVehicle) {

  const title =
    initialVehicle.querySelector(
      "h4"
    );


  const vehicleName =
    title
      ? title.textContent.trim()
      : "Economy Sedan";


  updatePassengerLimit(
    vehicleName
  );

} else {

  updatePassengerLimit(
    "Economy Sedan"
  );

}

/* =====================================================
GET VEHICLE
===================================================== */

function getSelectedVehicle() {

const selected =
document.querySelector(
".vehicle-card.active"
);

if (!selected) {

return {

  name:
    "Economy Sedan",

  pricePerKm:
    1.10

};

}

const title =
selected.querySelector(
"h4"
);

const vehicleName =
title
? title.textContent.trim()
: "Economy Sedan";

const lowerName =
vehicleName.toLowerCase();

let pricePerKm =
1.10;

/* =================================================
VEHICLE KM PRICES
================================================= */

if (
lowerName.includes(
"vip"
) &&
lowerName.includes(
"vito"
)
) {

pricePerKm =
  1.30;

} else if (
lowerName.includes(
"vito"
)
) {

pricePerKm =
  1.20;

} else if (
lowerName.includes(
"sprinter"
)
) {

pricePerKm =
  1.50;

} else if (
lowerName.includes(
"sedan"
) ||
lowerName.includes(
"economy"
)
) {

pricePerKm =
  1.10;

}

return {

name:
  vehicleName,

pricePerKm:
  pricePerKm

};

}

/* =====================================================
GET COORDINATES
===================================================== */

function getAddressCoordinates(
inputId
) {

const input =
document.getElementById(
inputId
);

if (!input) {
return null;
}

if (
input.dataset.lat &&
input.dataset.lon
) {

const lat =
  parseFloat(
    input.dataset.lat
  );


const lon =
  parseFloat(
    input.dataset.lon
  );


if (
  !isNaN(lat) &&
  !isNaN(lon)
) {

  return {

    lat:
      lat,

    lon:
      lon

  };

}

}

return null;

}

/* =====================================================
GEOCODE FALLBACK
===================================================== */

async function geocodeAddress(
address
) {

if (!address) {

throw new Error(
  "Address is empty."
);

}

const params =
new URLSearchParams({

  format:
    "jsonv2",

  addressdetails:
    "1",

  limit:
    "1",

  countrycodes:
    "tr",

  q:
    address

});

const url =
"https://nominatim.openstreetmap.org/search?" +
params.toString();

const response =
await fetch(
url,
{
headers: {
"Accept":
"application/json"
}
}
);

if (!response.ok) {

throw new Error(
  "Address service error: " +
  response.status
);

}

const data =
await response.json();

if (
!data ||
!data.length
) {

throw new Error(
  "Address not found: " +
  address
);

}

return {

lat:
  parseFloat(
    data[0].lat
  ),

lon:
  parseFloat(
    data[0].lon
  )

};

}

/* =====================================================
ROUTE DISTANCE
===================================================== */

async function calculateRouteDistance(
pickupAddress,
destinationAddress,
pickupInputId = "pickup",
destinationInputId = "dropoff"
) {

let pickupCoordinates =
getAddressCoordinates(
pickupInputId
);

let destinationCoordinates =
getAddressCoordinates(
destinationInputId
);

/* =================================================
FALLBACK
================================================= */

if (!pickupCoordinates) {

pickupCoordinates =
  await geocodeAddress(
    pickupAddress
  );

}

if (!destinationCoordinates) {

destinationCoordinates =
  await geocodeAddress(
    destinationAddress
  );

}

console.log(
"ROUTE COORDINATES:",
{
pickup:
pickupCoordinates,

  destination:
    destinationCoordinates

}

);

/* =================================================
OSRM
================================================= */

const routeUrl =
"https://router.project-osrm.org/route/v1/driving/" +

pickupCoordinates.lon + 
"," + 
pickupCoordinates.lat + 

";" + 

destinationCoordinates.lon + 
"," + 
destinationCoordinates.lat + 

"?overview=false"; 

const routeResponse =
await fetch(
routeUrl
);

if (!routeResponse.ok) {

throw new Error( 
  "Route calculation failed." 
); 

}

const routeData =
await routeResponse.json();

if (
!routeData.routes ||
!routeData.routes.length
) {

throw new Error( 
  "Route not found." 
); 

}

const distanceKm =
routeData.routes[0].distance /
1000;

console.log(
"OSRM DISTANCE:",
distanceKm,
"KM"
);

return distanceKm;

}

/* =====================================================
FORM SUBMIT
===================================================== */

form.addEventListener(
"submit",
async function (event) {

event.preventDefault(); 

/* ================================================= 
   BASIC DATA 
================================================= */ 

const pickup = 
  document 
    .getElementById("pickup") 
    ?.value 
    .trim() || ""; 


const dropoff = 
  document 
    .getElementById("dropoff") 
    ?.value 
    .trim() || ""; 


const pickupDateTimeInput =
  document.getElementById("pickupDateTime");

const pickupDateTime =
  pickupDateTimeInput?.value || "";


/* =================================================
   PREVENT PAST DATE & TIME
================================================= */

if (pickupDateTimeInput) {

  const now = new Date();

  const selectedDateTime =
    new Date(pickupDateTime);

  if (
    pickupDateTime &&
    selectedDateTime < now
  ) {

    alert(
      "Please select a future date and time."
    );

    pickupDateTimeInput.value = "";

    pickupDateTimeInput.focus();

    return;
  }


  const year =
    now.getFullYear();

  const month =
    String(now.getMonth() + 1)
      .padStart(2, "0");

  const day =
    String(now.getDate())
      .padStart(2, "0");

  const hours =
    String(now.getHours())
      .padStart(2, "0");

  const minutes =
    String(now.getMinutes())
      .padStart(2, "0");

  pickupDateTimeInput.min =
    `${year}-${month}-${day}T${hours}:${minutes}`;
}


const passengers = 
  parseInt( 
    document 
      .getElementById("passengers") 
      ?.value || "1", 
    10 
  );
  /* =================================================
   PASSENGER LIMIT CHECK
================================================= */

const selectedVehicle =
  getSelectedVehicle();


const maxPassengers =
  getMaxPassengers(
    selectedVehicle.name
  );


if (
  passengers < 1 ||
  passengers > maxPassengers
) {

  alert(
    "Maximum " +
    maxPassengers +
    " passengers are allowed for " +
    selectedVehicle.name +
    "."
  );

  return;

}


const isRoundTrip = 
  toggle 
    ? toggle.checked 
    : false; 


/* ================================================= 
   RETURN 
================================================= */ 

const returnPickup = 
  document 
    .getElementById( 
      "returnPickup" 
    ) 
    ?.value 
    .trim() || ""; 


const returnDropoff = 
  document 
    .getElementById( 
      "returnDropoff" 
    ) 
    ?.value 
    .trim() || ""; 


const returnDateTime = 
  document 
    .getElementById( 
      "returnDateTime" 
    ) 
    ?.value || ""; 


/* ================================================= 
   FLIGHTS 
================================================= */ 

const pickupFlightInput = 
  getFlightInput( 
    "pickupFlightWrapper", 
    "pickupFlight" 
  ); 


const dropoffFlightInput = 
  getFlightInput( 
    "dropoffFlightWrapper", 
    "dropoffFlightNumber" 
  ); 


const returnPickupFlightInput = 
  getFlightInput( 
    "returnPickupFlightWrapper", 
    "returnPickupFlightNumber" 
  ); 


const returnDropoffFlightInput = 
  getFlightInput( 
    "returnDropoffFlightWrapper", 
    "returnDropoffFlightNumber" 
  ); 


const pickupFlightNumber = 
  pickupFlightInput 
    ? pickupFlightInput.value.trim() 
    : ""; 


const dropoffFlightNumber = 
  dropoffFlightInput 
    ? dropoffFlightInput.value.trim() 
    : ""; 


const returnPickupFlightNumber = 
  returnPickupFlightInput 
    ? returnPickupFlightInput.value.trim() 
    : ""; 


const returnDropoffFlightNumber = 
  returnDropoffFlightInput 
    ? returnDropoffFlightInput.value.trim() 
    : ""; 


/* ================================================= 
   REQUIRED 
================================================= */ 

if ( 
  !pickup || 
  !dropoff || 
  !pickupDateTime 
) { 

  alert( 
    "Please complete Pickup Location, Destination and Date & Time." 
  ); 

  return; 

} 


/* ================================================= 
   COORDINATES 
================================================= */ 

const pickupCoordinates = 
  getAddressCoordinates( 
    "pickup" 
  ); 


const dropoffCoordinates = 
  getAddressCoordinates( 
    "dropoff" 
  ); 


if (!pickupCoordinates) { 

  alert( 
    "Please select a Pickup Location from the address suggestions." 
  ); 


  document 
    .getElementById("pickup") 
    ?.focus(); 


  return; 

} 


if (!dropoffCoordinates) { 

  alert( 
    "Please select a Destination from the address suggestions." 
  ); 


  document 
    .getElementById("dropoff") 
    ?.focus(); 


  return; 

} 


/* ================================================= 
   AIRPORT CHECK 
================================================= */ 

const pickupIsAirport = 
  document 
    .getElementById( 
      "pickup" 
    ) 
    ?.dataset.isAirport === 
    "true" || 
  isAirport(pickup); 


const dropoffIsAirport = 
  document 
    .getElementById( 
      "dropoff" 
    ) 
    ?.dataset.isAirport === 
    "true" || 
  isAirport(dropoff); 


if ( 
  pickupIsAirport && 
  !pickupFlightNumber 
) { 

  alert( 
    "Please enter your pickup flight number." 
  ); 


  if (pickupFlightInput) { 
    pickupFlightInput.focus(); 
  } 


  return; 

} 
/* ================================================= 
   ROUND TRIP CHECK 
================================================= */ 

if (isRoundTrip) { 

  if ( 
    !returnPickup || 
    !returnDropoff || 
    !returnDateTime 
  ) { 

    alert( 
      "Please complete the Return Journey details." 
    ); 

    return; 

  } 
  /* =================================================

RETURN COORDINATES
================================================= */

const returnPickupCoordinates =
getAddressCoordinates(
"returnPickup"
);

const returnDropoffCoordinates =
getAddressCoordinates(
"returnDropoff"
);

if (!returnPickupCoordinates) {

alert(
"Please select the Return Pickup Location from the address suggestions."
);

document
.getElementById("returnPickup")
?.focus();

return;

}

if (!returnDropoffCoordinates) {

alert(
"Please select the Return Destination from the address suggestions."
);

document
.getElementById("returnDropoff")
?.focus();

return;

}

  const returnPickupIsAirport = 
    document 
      .getElementById( 
        "returnPickup" 
      ) 
      ?.dataset.isAirport === 
      "true" || 
    isAirport( 
      returnPickup 
    ); 


  const returnDropoffIsAirport = 
    document 
      .getElementById( 
        "returnDropoff" 
      ) 
      ?.dataset.isAirport === 
      "true" || 
    isAirport( 
      returnDropoff 
    ); 


  if ( 
    returnPickupIsAirport && 
    !returnPickupFlightNumber 
  ) { 

    alert( 
      "Please enter the return pickup flight number." 
    ); 

    if ( 
      returnPickupFlightInput 
    ) { 

      returnPickupFlightInput.focus(); 

    } 

    return; 

  } 


  if ( 
    returnDropoffIsAirport && 
    !returnDropoffFlightNumber 
  ) { 

    alert( 
      "Please enter the return destination flight number." 
    ); 

    if ( 
      returnDropoffFlightInput 
    ) { 

      returnDropoffFlightInput.focus(); 

    } 

    return; 

  } 

} 


/* ================================================= 
   VEHICLE 
================================================= */ 

const vehicle = 
  getSelectedVehicle(); 


const vehicleName = 
  vehicle.name; 


const pricePerKm = 
  vehicle.pricePerKm; 


/* ================================================= 
   DISTANCE 
================================================= */ 

let outboundDistanceKm = 
  0; 


let returnDistanceKm = 
  0; 


let distanceKm = 
  0; 


let calculatedPrice = 
  0; 


try { 

  /* =============================================== 
     OUTBOUND 
  =============================================== */ 

  outboundDistanceKm = 
    await calculateRouteDistance( 
      pickup, 
      dropoff, 
      "pickup", 
      "dropoff" 
    ); 


  /* =============================================== 
     RETURN 
  =============================================== */ 

  if (isRoundTrip) { 

    returnDistanceKm = 
      await calculateRouteDistance( 
        returnPickup, 
        returnDropoff, 
        "returnPickup", 
        "returnDropoff" 
      ); 

  } 


  /* =============================================== 
     TOTAL KM 
  =============================================== */ 

  distanceKm = 
    outboundDistanceKm + 
    returnDistanceKm; 


 /* ===============================================
   NEW PRICING SYSTEM
   FIRST 40 KM = FIXED PRICE
   OVER 40 KM = EXTRA KM PRICE
=============================================== */

let basePrice = 0;
let extraKmPrice = pricePerKm;


/* ===============================================
   VEHICLE BASE PRICE - FIRST 40 KM
=============================================== */

const vehicleLower =
  vehicleName.toLowerCase();


if (
  vehicleLower.includes("vip") &&
  vehicleLower.includes("vito")
) {

  /* VIP VITO */

  basePrice = 55;
  extraKmPrice = 1.30;

} else if (
  vehicleLower.includes("vito")
) {

  /* VITO */

  basePrice = 45;
  extraKmPrice = 1.20;

} else if (
  vehicleLower.includes("sprinter")
) {

  /* SPRINTER */

  basePrice = 65;
  extraKmPrice = 1.50;

} else {

  /* SEDAN */

  basePrice = 40;
  extraKmPrice = 1.10;

}


/* ===============================================
   CALCULATE PRICE
=============================================== */

if (distanceKm <= 40) {

  /*
   * 40 KM OR LESS
   * FIXED PRICE
   */

  calculatedPrice =
    basePrice;

} else {

  /*
   * MORE THAN 40 KM
   * BASE PRICE + EXTRA KM
   */

  const extraKm =
    distanceKm - 40;


  calculatedPrice =
    basePrice +
    (
      extraKm *
      extraKmPrice
    );

}


/* ===============================================
   ROUND UP EURO
=============================================== */

calculatedPrice =
  Math.ceil(
    calculatedPrice
  );


console.log(
  "PRICING SYSTEM:",
  {
    vehicle:
      vehicleName,

    distanceKm:
      distanceKm,

    basePrice:
      basePrice,

    extraKm:
      Math.max(
        0,
        distanceKm - 40
      ),

    extraKmPrice:
      extraKmPrice,

    totalPrice:
      calculatedPrice
  }
);

  console.log( 
    "TOTAL DISTANCE:", 
    distanceKm, 
    "KM" 
  ); 


  console.log( 
    "PRICE PER KM:", 
    pricePerKm 
  ); 


  console.log( 
    "TOTAL PRICE:", 
    calculatedPrice 
  ); 


} catch (error) { 

  console.error( 
    "DISTANCE CALCULATION ERROR:", 
    error 
  ); 


  alert( 
    "Route distance could not be calculated. Please try again." 
  ); 


  return; 

} 


const vehiclePrice = 
  "€" + 
  calculatedPrice; 

/* =====================================================
REMOVE OLD SUMMARY
===================================================== */

const oldSummary = 
  document.querySelector( 
    ".booking-summary" 
  ); 


if (oldSummary) { 
  oldSummary.remove(); 
} 


/* ================================================= 
   SUMMARY 
================================================= */ 

let summary = ` 

  <div class="booking-summary"> 

    <div class="summary-header"> 

      <h3> 
        Booking Summary 
      </h3> 

      <button 
        type="button" 
        class="close-summary" 
      > 
        × 
      </button> 

    </div> 




    <div class="summary-row"> 

      <span> 
        Date & Time 
      </span> 

      <strong> 
        ${escapeHtml( 
          pickupDateTime.replace( 
            "T", 
            " " 
          ) 
        )} 
      </strong> 

    </div> 


    <div class="summary-row"> 

      <span> 
        Passengers 
      </span> 

      <strong> 
        ${passengers} 
      </strong> 

    </div> 


    <div class="summary-row"> 

      <span> 
        Vehicle 
      </span> 

      <strong> 
        ${escapeHtml(vehicleName)} 
      </strong> 

    </div> 


    <div class="summary-row"> 

      <span> 
        Distance 
      </span> 

      <strong> 
        ${distanceKm.toFixed(1)} km 
      </strong> 

    </div> 


    <div class="summary-row"> 

      <span> 
        Trip 
      </span> 

      <strong> 
        ${ 
          isRoundTrip 
            ? "Round Trip" 
            : "One Way" 
        } 
      </strong> 

    </div> 

`; 


/* ================================================= 
   FLIGHTS 
================================================= */ 

if (pickupIsAirport) { 

  summary += ` 

    <div class="summary-row"> 

      <span> 
        Pickup Flight 
      </span> 

      <strong> 
        ${escapeHtml( 
          pickupFlightNumber 
        )} 
      </strong> 

    </div> 

  `; 

} 


if (dropoffIsAirport) { 

  summary += ` 

    <div class="summary-row"> 

      <span> 
        Destination Flight 
      </span> 

      <strong> 
        ${escapeHtml( 
          dropoffFlightNumber 
        )} 
      </strong> 

    </div> 

  `; 

} 


/* ================================================= 
   RETURN SUMMARY 
================================================= */ 

if (isRoundTrip) { 

  summary += ` 

    <div class="summary-return"> 

      <h4> 
        ↩ Return Journey 
      </h4> 


      <div class="summary-row"> 

        <span> 
          Pickup 
        </span> 

        <strong> 
          ${escapeHtml( 
            returnPickup 
          )} 
        </strong> 

      </div> 


      <div class="summary-row"> 

        <span> 
          Destination 
        </span> 

        <strong> 
          ${escapeHtml( 
            returnDropoff 
          )} 
        </strong> 

      </div> 


      <div class="summary-row"> 

        <span> 
          Date & Time 
        </span> 

        <strong> 
          ${escapeHtml( 
            returnDateTime.replace( 
              "T", 
              " " 
            ) 
          )} 
        </strong> 

      </div> 

  `; 


  if ( 
    returnPickupIsAirport 
  ) { 

    summary += ` 

      <div class="summary-row"> 

        <span> 
          Return Pickup Flight 
        </span> 

        <strong> 
          ${escapeHtml( 
            returnPickupFlightNumber 
          )} 
        </strong> 

      </div> 

    `; 

  } 


  if ( 
    returnDropoffIsAirport 
  ) { 

    summary += ` 

      <div class="summary-row"> 

        <span> 
          Return Destination Flight 
        </span> 

        <strong> 
          ${escapeHtml( 
            returnDropoffFlightNumber 
          )} 
        </strong> 

      </div> 

    `; 

  } 


  summary += ` 

    </div> 

  `; 

} 

/* =================================================
PRICE + PAYMENT METHOD
===================================================== */

summary += `

<div class="summary-price"> 

  <span> 
    Estimated Price 
  </span> 

  <strong> 
    ${vehiclePrice} 
  </strong> 

</div> 


<div class="payment-method-section"> 

  <div class="payment-method-title"> 
    <span>Payment Method</span> 
    <small>* Required</small> 
  </div> 


  <div class="payment-method-options"> 

    <button 
      type="button" 
      class="payment-option" 
      data-payment="Cash" 
    > 

      <span class="payment-option-left"> 
        <span class="payment-icon">💶</span> 

        <span class="payment-text"> 
          <strong>Cash</strong> 
          <small>Pay directly to the driver</small> 
        </span> 
      </span> 


      <span class="payment-radio"></span> 

    </button> 

  </div> 


  <input 
    type="hidden" 
    id="paymentMethod" 
    value="" 
  > 

  <div 
    class="payment-error" 
    style="display:none;" 
  > 
    Please select a payment method. 
  </div> 

</div> 


<button 
  type="button" 
  class="continue-booking" 
> 
  CONTINUE BOOKING → 
</button> 

  </div> 

`;

/* ================================================= 
   SHOW SUMMARY 
================================================= */ 

form.insertAdjacentHTML( 
  "afterend", 
  summary 
); 

/* =================================================
PAYMENT METHOD SELECTION
===================================================== */

const paymentOptions =
document.querySelectorAll(
".payment-option"
);

paymentOptions.forEach(
function (option) {

option.addEventListener( 
  "click", 
  function () { 

    paymentOptions.forEach( 
      function (item) { 

        item.classList.remove( 
          "selected" 
        ); 

      } 
    ); 


    option.classList.add( 
      "selected" 
    ); 


    const paymentMethod = 
      document.getElementById( 
        "paymentMethod" 
      ); 


    if (paymentMethod) { 

      paymentMethod.value = 
        option.dataset.payment; 

    } 


    const paymentError = 
      document.querySelector( 
        ".payment-error" 
      ); 


    if (paymentError) { 

      paymentError.style.display = 
        "none"; 

    } 

  } 
); 

}
);

/* ================================================= 
   CLOSE 
================================================= */ 

const closeButton = 
  document.querySelector( 
    ".close-summary" 
  ); 


if (closeButton) { 

  closeButton.addEventListener( 
    "click", 
    function () { 

      const box = 
        document.querySelector( 
          ".booking-summary" 
        ); 


      if (box) { 
        box.remove(); 
      } 

    } 
  ); 

} 


/* ================================================= 
   CONTINUE 
================================================= */ 

const continueButton = 
  document.querySelector( 
    ".continue-booking" 
  ); 


if (!continueButton) { 
  return; 
} 


continueButton.addEventListener( 
  "click", 
  function () { 
    const paymentMethod = 

document.getElementById("paymentMethod");

const paymentError =
document.querySelector(".payment-error");

if (
!paymentMethod ||
!paymentMethod.value
) {

if (paymentError) {
paymentError.style.display = "block";
}

return;

}

if (paymentError) {
paymentError.style.display = "none";
}

    if ( 
      document.querySelector( 
        ".customer-details" 
      ) 
    ) { 

      return; 

    } 


    let customerDetails = ` 

      <div class="customer-details"> 

        <h3> 
          👤 Main Passenger 
        </h3> 


        <div class="customer-form-grid"> 

          <div class="customer-field"> 

            <label> 
              First Name * 
            </label> 

            <input 
              type="text" 
              id="customerFirstName" 
              placeholder="First Name" 
            > 

          </div> 


          <div class="customer-field"> 

            <label> 
              Last Name * 
            </label> 

            <input 
              type="text" 
              id="customerLastName" 
              placeholder="Last Name" 
            > 

          </div> 


          <div class="customer-field"> 

            <label> 
              Email Address * 
            </label> 

            <input 
              type="email" 
              id="customerEmail" 
              placeholder="your@email.com" 
            > 

          </div> 


          <div class="customer-field"> 

  <label> 
    WhatsApp / Phone * 
  </label> 

  <div class="phone-input-wrapper"> 

<select id="customerPhoneCountry"> 
  <option value="+90" data-flag="🇹🇷">🇹🇷 +90</option> 
  <option value="+1" data-flag="🇺🇸">🇺🇸 +1</option> 
  <option value="+44" data-flag="🇬🇧">🇬🇧 +44</option> 
  <option value="+49" data-flag="🇩🇪">🇩🇪 +49</option> 
  <option value="+33" data-flag="🇫🇷">🇫🇷 +33</option> 
  <option value="+39" data-flag="🇮🇹">🇮🇹 +39</option> 
  <option value="+34" data-flag="🇪🇸">🇪🇸 +34</option> 
  <option value="+31" data-flag="🇳🇱">🇳🇱 +31</option> 
  <option value="+32" data-flag="🇧🇪">🇧🇪 +32</option> 
  <option value="+41" data-flag="🇨🇭">🇨🇭 +41</option> 
  <option value="+43" data-flag="🇦🇹">🇦🇹 +43</option> 
  <option value="+40" data-flag="🇷🇴">🇷🇴 +40</option> 
  <option value="+359" data-flag="🇧🇬">🇧🇬 +359</option> 
  <option value="+30" data-flag="🇬🇷">🇬🇷 +30</option> 
  <option value="+351" data-flag="🇵🇹">🇵🇹 +351</option> 
  <option value="+48" data-flag="🇵🇱">🇵🇱 +48</option> 
  <option value="+420" data-flag="🇨🇿">🇨🇿 +420</option> 
  <option value="+36" data-flag="🇭🇺">🇭🇺 +36</option> 
  <option value="+381" data-flag="🇷🇸">🇷🇸 +381</option> 
  <option value="+382" data-flag="🇲🇪">🇲🇪 +382</option> 
  <option value="+385" data-flag="🇭🇷">🇭🇷 +385</option> 
  <option value="+386" data-flag="🇸🇮">🇸🇮 +386</option> 
  <option value="+387" data-flag="🇧🇦">🇧🇦 +387</option> 
  <option value="+389" data-flag="🇲🇰">🇲🇰 +389</option> 
  <option value="+355" data-flag="🇦🇱">🇦🇱 +355</option> 
  <option value="+7" data-flag="🇷🇺">🇷🇺 +7</option> 
  <option value="+380" data-flag="🇺🇦">🇺🇦 +380</option> 
  <option value="+971" data-flag="🇦🇪">🇦🇪 +971</option> 
  <option value="+974" data-flag="🇶🇦">🇶🇦 +974</option> 
  <option value="+966" data-flag="🇸🇦">🇸🇦 +966</option> 
  <option value="+972" data-flag="🇮🇱">🇮🇱 +972</option> 
  <option value="+20" data-flag="🇪🇬">🇪🇬 +20</option> 
  <option value="+212" data-flag="🇲🇦">🇲🇦 +212</option> 
  <option value="+216" data-flag="🇹🇳">🇹🇳 +216</option> 
  <option value="+213" data-flag="🇩🇿">🇩🇿 +213</option> 
  <option value="+27" data-flag="🇿🇦">🇿🇦 +27</option> 
  <option value="+91" data-flag="🇮🇳">🇮🇳 +91</option> 
  <option value="+86" data-flag="🇨🇳">🇨🇳 +86</option> 
  <option value="+81" data-flag="🇯🇵">🇯🇵 +81</option> 
  <option value="+82" data-flag="🇰🇷">🇰🇷 +82</option> 
  <option value="+61" data-flag="🇦🇺">🇦🇺 +61</option> 
  <option value="+64" data-flag="🇳🇿">🇳🇿 +64</option> 
  <option value="+55" data-flag="🇧🇷">🇧🇷 +55</option> 
  <option value="+52" data-flag="🇲🇽">🇲🇽 +52</option> 
  <option value="+54" data-flag="🇦🇷">🇦🇷 +54</option> 
  <option value="+56" data-flag="🇨🇱">🇨🇱 +56</option> 
  <option value="+57" data-flag="🇨🇴">🇨🇴 +57</option> 
</select> 

<input 
  type="tel" 
  id="customerPhone" 
  placeholder="Phone number" 
  autocomplete="tel" 
  inputmode="tel" 
> 

  </div> 
</div> 

          <div class="customer-field full"> 

            <label> 
              Passport Number 
              <span>(Optional)</span> 
            </label> 

            <input 
              type="text" 
              id="customerPassport" 
              placeholder="Passport number" 
            > 

          </div> 


          <div class="customer-field full"> 

            <label> 
              Special Request 
              <span>(Optional)</span> 
            </label> 

            <textarea 
              id="customerRequest" 
              placeholder="Any special requests?" 
            ></textarea> 

          </div> 

        </div> 

    `; 


    /* ================================================= 
       OTHER GUESTS 
    ================================================= */ 

    if (passengers > 1) { 

      customerDetails += ` 

        <div class="other-guests"> 

          <h3> 
            👥 Other Guests 
          </h3> 

      `; 


      for ( 
        let i = 2; 
        i <= passengers; 
        i++ 
      ) { 

        customerDetails += ` 

          <div class="guest-card"> 

            <h4> 
              Guest ${i} 
            </h4> 


            <div class="customer-form-grid"> 

              <div class="customer-field"> 

                <label> 
                  First Name * 
                </label> 

                <input 
                  type="text" 
                  id="guest${i}FirstName" 
                  placeholder="First Name" 
                > 

              </div> 


              <div class="customer-field"> 

                <label> 
                  Last Name * 
                </label> 

                <input 
                  type="text" 
                  id="guest${i}LastName" 
                  placeholder="Last Name" 
                > 

              </div> 


              <div class="customer-field full"> 

                <label> 
                  Passport Number * 
                </label> 

                <input 
                  type="text" 
                  id="guest${i}Passport" 
                  placeholder="Passport number" 
                > 

              </div> 

            </div> 

          </div> 

        `; 

      } 


      customerDetails += ` 

        </div> 

      `; 

    } 


    /* =================================================

SEND BOOKING BUTTON
================================================= */

customerDetails += `

<button
  type="button"
  class="confirm-booking"
>
  SEND BOOKING →
</button>

  </div>

`;

    const bookingSummary = 
      document.querySelector( 
        ".booking-summary" 
      ); 


    if (bookingSummary) { 

      bookingSummary.insertAdjacentHTML( 
        "beforeend", 
        customerDetails 
      ); 

    } 


    /* ================================================= 
       SCROLL 
    ================================================= */ 

    const details = 
      document.querySelector( 
        ".customer-details" 
      ); 


    if (details) { 

      setTimeout( 
        function () { 

          details.scrollIntoView({ 
            behavior: 
              "smooth", 

            block: 
              "center" 

          }); 

        }, 
        100 
      ); 

    } 


    /* ================================================= 
       CONFIRM BOOKING 
    ================================================= */ 

    const confirmButton = 
      document.querySelector( 
        ".confirm-booking" 
      ); 


    if (!confirmButton) { 
      return; 
    } 


    confirmButton.addEventListener( 
      "click", 
      async function () { 

        /* ============================================= 
           MAIN PASSENGER 
        ============================================= */ 

        const firstName = 
          document 
            .getElementById( 
              "customerFirstName" 
            ) 
            ?.value 
            .trim() || ""; 


        const lastName = 
          document 
            .getElementById( 
              "customerLastName" 
            ) 
            ?.value 
            .trim() || ""; 


        const email = 
          document 
            .getElementById( 
              "customerEmail" 
            ) 
            ?.value 
            .trim() || ""; 


        const phoneInput = 

document.getElementById("customerPhone");

const phoneCountry =
document.getElementById("customerPhoneCountry");

const phoneNumber =
phoneInput
? phoneInput.value.trim()
: "";

const countryCode =
phoneCountry
? phoneCountry.value
: "+90";

const phone =
countryCode + phoneNumber.replace(/^0+/, "");

        const passport = 
          document 
            .getElementById( 
              "customerPassport" 
            ) 
            ?.value 
            .trim() || ""; 


        const specialRequest = 
          document 
            .getElementById( 
              "customerRequest" 
            ) 
            ?.value 
            .trim() || ""; 


        /* ============================================= 
           VALIDATION 
        ============================================= */ 

        if ( 
          !firstName || 
          !lastName || 
          !email || 
          !phone 
        ) { 

          alert( 
            "Please complete the main passenger's name, email and phone number." 
          ); 

          return; 

        } 
        /* =============================================

OTHER GUESTS
FINAL SUMMARY'DEN ÖNCE TOPLA
============================================= */

const guests = [];

if (passengers > 1) {

for (
let i = 2;
i <= passengers;
i++
) {

const guestFirstName =
  document
    .getElementById(
      `guest${i}FirstName`
    )
    ?.value
    .trim() || "";

const guestLastName =
  document
    .getElementById(
      `guest${i}LastName`
    )
    ?.value
    .trim() || "";

const guestPassport =
  document
    .getElementById(
      `guest${i}Passport`
    )
    ?.value
    .trim() || "";

if (
  !guestFirstName ||
  !guestLastName ||
  !guestPassport
) {

  alert(
    `Please complete Guest ${i}'s First Name, Last Name and Passport Number.`
  );

  return;

}

guests.push({

  firstName:
    guestFirstName,

  lastName:
    guestLastName,

  passport:
    guestPassport

});

}

}
/* =================================================
SHOW FINAL SUMMARY FIRST
================================================= */

const existingFinalSummary =
document.querySelector(
".final-booking-summary"
);

if (!existingFinalSummary) {

const finalSummary = document.createElement("div");

finalSummary.className =
"final-booking-summary";

finalSummary.innerHTML = `

<div class="final-summary-header">
  <h3>Booking Summary</h3>
</div>

<div class="final-summary-row">
  <span>Pickup</span>
  <strong>${escapeHtml(pickup)}</strong>
</div>

<div class="final-summary-row">
  <span>Destination</span>
  <strong>${escapeHtml(dropoff)}</strong>
</div>

<div class="final-summary-row">
  <span>Date & Time</span>
  <strong>
    ${escapeHtml(
      pickupDateTime.replace("T", " ")
    )}
  </strong>
</div>

<div class="final-summary-row">
  <span>Passengers</span>
  <strong>${passengers}</strong>
</div>

<div class="final-summary-row">
  <span>Vehicle</span>
  <strong>${escapeHtml(vehicleName)}</strong>
</div>

<div class="final-summary-row">
  <span>Distance</span>
  <strong>
    ${distanceKm.toFixed(1)} km
  </strong>
</div>

<div class="final-summary-row">
  <span>Trip</span>
  <strong>
    ${
      isRoundTrip
        ? "Round Trip"
        : "One Way"
    }
  </strong>
</div>

<div class="final-summary-row">
  <span>Price</span>
  <strong>${vehiclePrice}</strong>
</div>

<div class="final-summary-section">

  <h4>Main Passenger</h4>

  <div class="final-summary-row">
    <span>Name</span>
    <strong>
      ${escapeHtml(firstName)}
      ${escapeHtml(lastName)}
    </strong>
  </div>

  <div class="final-summary-row">
    <span>Email</span>
    <strong>${escapeHtml(email)}</strong>
  </div>

  <div class="final-summary-row">
    <span>Phone</span>
    <strong>${escapeHtml(phone)}</strong>
  </div>

  ${
    passport
      ? `
        <div class="final-summary-row">
          <span>Passport</span>
          <strong>
            ${escapeHtml(passport)}
          </strong>
        </div>
      `
      : ""
  }

</div>

${
  specialRequest
    ? `
      <div class="final-summary-row">
        <span>Special Request</span>
        <strong>
          ${escapeHtml(specialRequest)}
        </strong>
      </div>
    `
    : ""
}

${
  guests.length
    ? `
      <div class="final-summary-section">

        <h4>Other Guests</h4>

        ${guests
          .map(
            (guest, index) => `
              <div class="final-guest">

                <strong>
                  Guest ${index + 2}
                </strong>

                <div class="final-summary-row">
                  <span>Name</span>
                  <strong>
                    ${escapeHtml(
                      guest.firstName
                    )}
                    ${escapeHtml(
                      guest.lastName
                    )}
                  </strong>
                </div>

                <div class="final-summary-row">
                  <span>Passport</span>
                  <strong>
                    ${escapeHtml(
                      guest.passport
                    )}
                  </strong>
                </div>

              </div>
            `
          )
          .join("")}

      </div>
    `
    : ""
}

<button
  type="button"
  class="final-send-booking"
>
  SEND BOOKING →
</button>

`;

const customerDetails =
document.querySelector(
".customer-details"
);

if (customerDetails) {

customerDetails.appendChild(
  finalSummary
);

}
/* =============================================
FINAL SEND BUTTON
============================================= */

const finalSendButton =
finalSummary.querySelector(
".final-send-booking"
);

if (finalSendButton) {

finalSendButton.addEventListener(
"click",
async function () {

  /* =========================================
     BOOKING ROW
  ========================================= */

  const bookingRow = {

    pickup:
      pickup,

    dropoff:
      dropoff,

    pickup_datetime:
      pickupDateTime,

    passengers:
      String(passengers),

    trip_type:
      isRoundTrip
        ? "Round Trip"
        : "One Way",

    vehicle:
      vehicleName,

    price:
      vehiclePrice,

    status:
      "New",

    customer_first_name:
      firstName,

    customer_last_name:
      lastName,

    customer_email:
      email,

    customer_phone:
      phone,

    customer_passport:
      passport,

    customer_request:
      specialRequest,

    pickup_flight:
      pickupFlightNumber,

    destination_flight:
      dropoffFlightNumber,

    return_pickup:
      isRoundTrip
        ? returnPickup
        : "",

    return_destination:
      isRoundTrip
        ? returnDropoff
        : "",

    return_datetime:
      isRoundTrip
        ? returnDateTime
        : "",

    return_pickup_flight:
      isRoundTrip
        ? returnPickupFlightNumber
        : "",

    return_destination_flight:
      isRoundTrip
        ? returnDropoffFlightNumber
        : "",

    other_guests:
      guests,

    passengers_data: {

      mainPassenger: {

        firstName:
          firstName,

        lastName:
          lastName,

        email:
          email,

        phone:
          phone,

        passport:
          passport

      },

      guests:
        guests

    },

    guest_passengers:
      guests,

    first_name:
      firstName,

    last_name:
      lastName,

    email:
      email,

    phone:
      phone,

    passport:
      passport,

    trip:
      isRoundTrip
        ? "Round Trip"
        : "One Way",

    special_request:
      specialRequest

  };


  try {

    finalSendButton.disabled =
      true;

    finalSendButton.textContent =
      "SENDING...";


    /* =========================================
       SUPABASE
    ========================================= */

    const response =
      await fetch(
        SUPABASE_URL +
        "/rest/v1/bookings",
        {

          method:
            "POST",

          headers: {

            "apikey":
              SUPABASE_KEY,

            "Authorization":
              "Bearer " +
              SUPABASE_KEY,

            "Content-Type":
              "application/json",

            "Accept":
              "application/json",

            "Prefer":
              "return=minimal"

          },

          body:
            JSON.stringify(
              bookingRow
            )

        }
      );


    const responseText =
      await response.text();


    console.log(
      "SUPABASE STATUS:",
      response.status
    );

    console.log(
      "SUPABASE RESPONSE:",
      responseText
    );


    if (!response.ok) {

      throw new Error(
        responseText ||
        "Supabase booking error."
      );

    }    
    /* =========================================
   SEND CUSTOMER EMAIL
========================================= */

try {

  const emailResponse =
    await fetch(
      SUPABASE_URL +
      "/functions/v1/booking-email",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify({

          firstName: firstName,
          lastName: lastName,
          email: email,

          pickup: pickup,
          destination: dropoff,

          pickupDateTime:
            pickupDateTime,

          passengers:
            passengers,

          vehicle:
            vehicleName,

          price:
            vehiclePrice,

          distanceKm:
            Number(
              distanceKm.toFixed(2)
            ),

          trip:
            isRoundTrip
              ? "Round Trip"
              : "One Way",

          pickupFlight:
            pickupFlightNumber,

          destinationFlight:
            dropoffFlightNumber,

          returnPickup:
            isRoundTrip
              ? returnPickup
              : "",

          returnDestination:
            isRoundTrip
              ? returnDropoff
              : "",

          returnDateTime:
            isRoundTrip
              ? returnDateTime
              : "",

          specialRequest:
            specialRequest

        })

      }
    );

  const emailText =
    await emailResponse.text();

  console.log(
    "EMAIL STATUS:",
    emailResponse.status
  );

  console.log(
    "EMAIL RESPONSE:",
    emailText
  );

  if (!emailResponse.ok) {

    console.error(
      "CUSTOMER EMAIL FAILED:",
      emailText
    );

  } else {

    console.log(
      "CUSTOMER EMAIL SENT ✓"
    );

  }

} catch (emailError) {

  console.error(
    "EMAIL ERROR:",
    emailError
  );

}

    /* =========================================
       SUCCESS
    ========================================= */

    finalSendButton.textContent =
      "BOOKING RECEIVED ✓";


    /* =========================================
       SUCCESS SCREEN
    ========================================= */

    const successOverlay =
      document.createElement(
        "div"
      );


    successOverlay.className =
      "booking-success-overlay";


    successOverlay.innerHTML = `

      <div class="booking-success-box">

        <div class="booking-success-icon">
          ✓
        </div>

        <h2>
          Booking Confirmed
        </h2>

        <p>
          Your booking has been successfully received.
          <br>
          We will contact you shortly with the confirmation details.
        </p>

        <div class="success-booking-number">
          BOOKING RECEIVED ✓
        </div>

        <button
          type="button"
          class="new-booking-button"
        >
          NEW BOOKING
        </button>

      </div>

    `;


    document.body.appendChild(
      successOverlay
    );


    const newBookingButton =
      successOverlay.querySelector(
        ".new-booking-button"
      );


    if (newBookingButton) {

      newBookingButton.addEventListener(
        "click",
        function () {

          window.location.reload();

        }
      );

    }


  } catch (error) {

    console.error(
      "SUPABASE ERROR:",
      error
    );


    alert(
      "Booking could not be saved.\n\n" +
      error.message
    );


    finalSendButton.disabled =
      false;

    finalSendButton.textContent =
      "SEND BOOKING →";

  }

}

);

}

finalSummary.scrollIntoView({
behavior: "smooth",
block: "center"
});

return;

}

        /* ============================================= 
           BOOKING ROW 
        ============================================= */ 

        const bookingRow = { 

          pickup: 
            pickup, 

          dropoff: 
            dropoff, 

          pickup_datetime: 
            pickupDateTime, 

          passengers: 
            String( 
              passengers 
            ), 

          trip_type: 
            isRoundTrip 
              ? "Round Trip" 
              : "One Way", 

          vehicle: 
            vehicleName, 

          price: 
            vehiclePrice, 

          status: 
            "New", 

          customer_first_name: 
            firstName, 

          customer_last_name: 
            lastName, 

          customer_email: 
            email, 

          customer_phone: 
            phone, 

          customer_passport: 
            passport, 

          customer_request: 
            specialRequest, 

          pickup_flight: 
            pickupFlightNumber, 

          destination_flight: 
            dropoffFlightNumber, 

          return_pickup: 
            isRoundTrip 
              ? returnPickup 
              : "", 

          return_destination: 
            isRoundTrip 
              ? returnDropoff 
              : "", 

          return_datetime: 
            isRoundTrip 
              ? returnDateTime 
              : "", 

          return_pickup_flight: 
            isRoundTrip 
              ? returnPickupFlightNumber 
              : "", 

          return_destination_flight: 
            isRoundTrip 
              ? returnDropoffFlightNumber 
              : "", 

          other_guests: 
            guests, 

          passengers_data: { 

            mainPassenger: { 

              firstName: 
                firstName, 

              lastName: 
                lastName, 

              email: 
                email, 

              phone: 
                phone, 

              passport: 
                passport 

            }, 

            guests: 
              guests 

          }, 

          guest_passengers: 
            guests, 

          first_name: 
            firstName, 

          last_name: 
            lastName, 

          email: 
            email, 

          phone: 
            phone, 

          passport: 
            passport, 

          trip: 
            isRoundTrip 
              ? "Round Trip" 
              : "One Way", 

          special_request: 
            specialRequest 

          /* 
           * IMPORTANT: 
           * 
           * distance_km BURADAN ÇIKARILDI. 
           * 
           * Çünkü Supabase bookings tablosunda 
           * bu sütun yok ve POST işlemini 
           * tamamen durduruyordu. 
           */ 

        }; 


        console.log( 
          "SUPABASE BOOKING:", 
          bookingRow 
        ); 


        /* ============================================= 
           SEND SUPABASE 
        ============================================= */ 

        try { 

          confirmButton.disabled = 
            true; 


          confirmButton.textContent = 
            "SENDING..."; 


          const response = 
            await fetch( 
              SUPABASE_URL + 
              "/rest/v1/bookings", 
              { 

                method: 
                  "POST", 

                headers: { 

                  "apikey": 
                    SUPABASE_KEY, 

                  "Authorization": 
                    "Bearer " + 
                    SUPABASE_KEY, 

                  "Content-Type": 
                    "application/json", 

                  "Accept": 
                    "application/json", 

                  "Prefer": 
                    "return=minimal" 

                }, 

                body: 
                  JSON.stringify( 
                    bookingRow 
                  ) 

              } 
            ); 


          const responseText = 
            await response.text(); 


          console.log( 
            "SUPABASE STATUS:", 
            response.status 
          ); 


          console.log( 
            "SUPABASE RESPONSE:", 
            responseText 
          ); 


          if (!response.ok) { 

            throw new Error( 
              responseText || 
              "Supabase booking error." 
            ); 

          } 


          /* =========================================
   CUSTOMER EMAIL
========================================= */

try {

  const emailResponse =
    await fetch(
      SUPABASE_URL +
      "/functions/v1/booking-email",
      {

        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify({

          customerEmail:
            email,

          firstName:
            firstName,

          lastName:
            lastName,

          pickup:
            pickup,

          destination:
            dropoff,

          pickupDateTime:
            pickupDateTime,

          passengers:
            passengers,

          vehicle:
            vehicleName,

          price:
            vehiclePrice,

          distanceKm:
            Number(
              distanceKm.toFixed(2)
            ),

          trip:
            isRoundTrip
              ? "Round Trip"
              : "One Way",

          pickupFlight:
            pickupFlightNumber,

          destinationFlight:
            dropoffFlightNumber,

          returnPickup:
            isRoundTrip
              ? returnPickup
              : "",

          returnDestination:
            isRoundTrip
              ? returnDropoff
              : "",

          returnDateTime:
            isRoundTrip
              ? returnDateTime
              : "",

          specialRequest:
            specialRequest,

          guests:
            guests

        })

      }
    );


  const emailResult =
    await emailResponse.text();


  console.log(
    "EMAIL STATUS:",
    emailResponse.status
  );


  console.log(
    "EMAIL RESPONSE:",
    emailResult
  );


  if (!emailResponse.ok) {

    console.error(
      "CUSTOMER EMAIL FAILED:",
      emailResult
    );

  } else {

    console.log(
      "CUSTOMER EMAIL SENT ✓"
    );

  }


} catch (emailError) {

  console.error(
    "CUSTOMER EMAIL ERROR:",
    emailError
  );

}
/* ========================================= 

SUCCESS
========================================= */

confirmButton.textContent =
"BOOKING RECEIVED ✓";

confirmButton.disabled =
true;

/* =========================================
SUCCESS SCREEN
========================================= */

const successOverlay =
document.createElement("div");

successOverlay.className =
"booking-success-overlay";

successOverlay.innerHTML = `

  <div class="booking-success-box"> 

<div class="booking-success-icon"> 
  ✓ 
</div> 

<h2> 
  Booking Confirmed 
</h2> 

<p> 
  Your booking has been successfully received. 
  <br> 
  We will contact you shortly with the confirmation details. 
</p> 

<div class="success-booking-number"> 
  BOOKING RECEIVED ✓ 
</div> 

<button 
  type="button" 
  class="new-booking-button" 
> 
  NEW BOOKING 
</button> 

  </div> 

`;

/* =========================================
SHOW SUCCESS SCREEN
========================================= */

document.body.appendChild(
successOverlay
);

/* =========================================
NEW BOOKING BUTTON
========================================= */

const newBookingButton =
successOverlay.querySelector(
".new-booking-button"
);

if (newBookingButton) {

newBookingButton.addEventListener(
"click",
function () {

  window.location.reload(); 

} 

);

}

        } catch (error) { 

          console.error( 
            "SUPABASE ERROR:", 
            error 
          ); 


          alert( 
            "Booking could not be saved.\n\n" + 
            error.message 
          ); 


          confirmButton.disabled = 
            false; 


          confirmButton.textContent = 
            "CONFIRM BOOKING →"; 

        } 

      } 
    ); 

  } 

); 

}

);
});
